import React from "react";
import efectivo from "../../../imagenes/checkout/payment-options/efectivo.png";
import efectivo2x from "../../../imagenes/checkout/payment-options/efectivo@2x.png";
// import TextoLeyPais from "./textoLeyPais";

const CuadroEfectivo = ({esInternacional, idMedioDePago, onMedioDePagoChange}) => {

  return (
    <li className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
            <div className="payment-card">
              <div className="md-radio">
                <input
                  type="radio"
                  id="efectivo"
                  checked={idMedioDePago === "1"}
                  name="medioDePago"
                  onChange={onMedioDePagoChange}
                  value="1"
                />
                <label htmlFor="efectivo">&nbsp;</label>
              </div>
              <h6>Efectivo</h6>
              <div className="icon-container">
                <img
                  src={efectivo}
                  alt="Icono de una mano entregando efectivo"
                  srcSet={efectivo + " 1x, " + efectivo2x + " 2x"}
                />
              </div>
              <p className="parrafoEnMedioDePago">
                {
                  esInternacional 
                  ? "Pagá tu viaje en cualquiera de nuestras sucursales. Recorda que solo lo podes hacer en U$D." 
                  : "Pagá tu viaje en cualquiera de las sucursales en la forma que prefieras."
                }
              </p>
              <p>elegir m&eacute;todo</p>
              {/*codigoMoneda !== "PES" && <TextoLeyPais />*/}
            </div>
          </li>
  );
};

export default CuadroEfectivo;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/Pago/cuadroEfectivo.js